import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TableTabIds } from '../utils';
import { useAdobeAnalytics } from '@/context/AdobeAnalyticsProvider';
import { AdobeAnalyticsConst } from '@/hooks/AdobeAnalyticsHooks/adobeAnalyticsConstants/adobeAnalyticsConstants';

export const useMyHCPsNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const analytics = useAdobeAnalytics();

  const navigateToFavorites = useCallback(
    (event?: { preventDefault?: () => void }) => {
      event?.preventDefault?.();

      const currentUrl = `/my-hcps?tabId=${TableTabIds.FAVORITES}`;
      const isCurrentlyOnFavoritesTab =
        location.pathname === '/my-hcps' && location.search.includes(`tabId=${TableTabIds.FAVORITES}`);

      if (isCurrentlyOnFavoritesTab) {
        // Force refresh by navigating with replace: false to trigger navigation
        navigate(currentUrl, { replace: false });
      } else {
        navigate(currentUrl);
      }

      analytics?.trackLinkClick({
        innertext: AdobeAnalyticsConst.BUTTON_TEXT.FAVORITES,
        position: AdobeAnalyticsConst.POSITIONS.APPLICATION_HEADER,
        type: AdobeAnalyticsConst.LINK_TYPES.BUTTON,
        name: AdobeAnalyticsConst.LINKCLICK_NAMES.FAVORITES,
      });
    },
    [navigate, analytics, location.pathname, location.search],
  );

  return {
    navigateToFavorites,
  };
};

export default useMyHCPsNavigation;
